"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _shallowEquals = _interopRequireDefault(require("unmutable/lib/shallowEquals"));

var _default = function _default(parcelA, parcelB) {
  if (!parcelA || !parcelB) {
    return false;
  }

  var aa = parcelA.data;
  var bb = parcelB.data;
  var isChild = parcelA.isChild() && parcelB.isChild();
  return aa.value === bb.value && aa.key === bb.key && aa.child === bb.child && (0, _shallowEquals.default)(aa.meta)(bb.meta) && (!isChild || parcelA.isFirst() === parcelB.isFirst() && parcelA.isLast() === parcelB.isLast());
};

exports.default = _default;